import React, { FC } from 'react'
import s from './ProductInfoSection.module.scss'
import { ReactComponent as AboutSectionLeftIcon } from './../../../assets/icons/PageProductsIcons/AboutSectionLeftIcon.svg'
import { ReactComponent as AboutSectionRightIcon } from './../../../assets/icons/PageProductsIcons/AboutSectionRightIcon.svg'
import { ReactComponent as Rectangle } from './../../../assets/icons/PageProductsIcons/Rectangle.svg'
import { BACKEND_URL } from '../../../api'
import { IProductFeatureItem } from '../../../store/types'

interface ProductInfoSectionProps {
    // About props
    aboutText?: string
    icon?: string
    // Features props
    featuresDescription?: string
    featuresList?: IProductFeatureItem[]
    featuresImage?: string
}

const ProductInfoSection: FC<ProductInfoSectionProps> = ({ 
    aboutText, 
    icon,
    featuresDescription,
    featuresList,
    featuresImage
}) => {
    // Если нет контента вообще, не рендерим секцию
    if (!aboutText && !featuresDescription && (!featuresList || featuresList.length === 0)) return null

    return (
        <section className={s.section}>
            <Rectangle className={s.Rectangle}/>
           
            <div className={`${s.container} container`}>
                {/* About Block */}
                {aboutText && (
                    <div className={s.aboutBlock}>
                        <div className={s.box_img}>
                            <div className={s.boxiconLeft}>
                                <AboutSectionLeftIcon className={s.iconLeft} />
                            </div>
                            <AboutSectionRightIcon className={s.iconRight} />
                        </div>
                        <div className={s.content}>
                            <h2 className='title'>О программном обеспечении</h2>
                            <article>{aboutText}</article>
                        </div>
                    </div>
                )}
                {/* Features Block */}
                {(featuresDescription || (featuresList && featuresList.length > 0)) && (
                    <div className={s.featuresBlock}>
                        <h2 className={`${s.title} title`}>Функциональные характеристики и задачи ПО</h2>
                        
                        {featuresDescription && (
                            <p className={s.description}>{featuresDescription}</p>
                        )}
                        
                        <h3>Программное обеспечение "PNX_DF" обладает следующими функциональными характеристиками:</h3>
                        
                        <div className={s.featuresWrapper}>
                            <div className={s.listWrapper}>
                                {featuresList && featuresList.length > 0 && (
                                    <ul className={s.featuresList}>
                                        {featuresList.map((item, index) => (
                                            <li key={item.id} className={s.featureItem}>
                                                <span className={s.number}>{index + 1}.</span>
                                                <span className={s.text}>{item.text}</span>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>

                            {featuresImage && (
                                <div className={s.imageWrapper}>
                                    <img src={BACKEND_URL + featuresImage} alt="Функциональные характеристики" />
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
            <div className={`${s.shapeRight}`} />
            <span className={`${s.gradientLine} lineGradient bottom-line`} />
        </section>
    )
}

export default ProductInfoSection

